// @ts-nocheck
import React, { createContext, useContext, useMemo, useState } from 'react';

import type { PropsWithChildren } from 'react';

type State = {
  activeTabId?: string;
};

type ContextValue = {
  activeTabId?: string;
  setActiveTab: (tabId: string) => void;
};

const TabsContext = createContext<ContextValue | null>(null);

type TabsContextProviderProps = {
  defaultTabId?: string;
  onTabClick?: (id: string) => void;
};

function TabsContextProvider({
  children,
  defaultTabId,
  onTabClick
}: PropsWithChildren<TabsContextProviderProps>): React.ReactElement {
  const [{ activeTabId }, setState] = useState<State>({ activeTabId: defaultTabId });

  const setActiveTab = (tabId: string): void => {
    onTabClick?.(tabId);
    setState(prev => ({
      ...prev,
      activeTabId: tabId
    }));
  };

  const value: ContextValue = useMemo(
    () => ({
      activeTabId,
      setActiveTab
    }),
    [activeTabId]
  );

  return <TabsContext.Provider value={value}>{children}</TabsContext.Provider>;
}

export const useTabsContext = (): ContextValue => {
  const context = useContext(TabsContext);
  if (!context) {
    throw new Error('useTabsContextProvider needs a TabsContextProvider');
  }
  return context;
};

export default TabsContextProvider;
